import React from 'react'
import {Box, Tooltip} from '@mui/material'
import {IVypuskSummary} from '@containers/monitoringPlatform/passengerCharts/types'
import {formatRange, formatTime} from '@containers/monitoringPlatform/passengerCharts/helpers/formatTime'
import sx from '@containers/monitoringPlatform/passengerCharts/overview/sx'

const Y_MAX = 50
const LIGHT_TEXT_SHARE = 0.55

const VypuskChips = ({vypusky}: {vypusky: IVypuskSummary[]}) => {
	return (
		<Box sx={sx.chips}>
			{vypusky.map((v) => {
				const share = Math.min(1, (v.peak ?? 0) / Y_MAX)
				const percent = Math.round((0.12 + 0.78 * share) * 100)
				return (
					<Tooltip
						key={v.scheduleId}
						title={<>
							Випуск {v.number} · {v.licencePlates.join(', ')}<br/>
							{formatRange(v.from, v.to)} · кіл {v.circlesDone}/{v.circlesTotal}<br/>
							пік {v.peak ?? '—'} о {formatTime(v.peakAt)} · сер. {v.avg ?? '—'}
						</>}
					>
						<Box sx={{
							...sx.chip,
							backgroundColor: `color-mix(in srgb, var(--account-accent, #0C6DDF) ${percent}%, transparent)`,
							color: share > LIGHT_TEXT_SHARE
								? 'var(--account-accent-contrast, #fff)'
								: 'var(--account-accent-text, #0C6DDF)',
						}}>
							{v.number}
						</Box>
					</Tooltip>
				)
			})}
		</Box>
	)
}

export default VypuskChips
